/**
 * Helper function to delete, read and write cookies.
 *
 * ```
 * // For example:
 * cookie.delete('key')
 * cookie.get('key')
 * cookie.set('key', 'value')
 * ```
 */
export const cookie = {
    delete(name: string): void {
      this.set(name, '', -1)
    },
    get(name: string): string | null {
      const value = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)
      return value ? decodeURIComponent(value[2]) : null
    },
    set(name: string, value: string, maxAge: number | null = null): void {
      name = encodeURIComponent(name)
      value = encodeURIComponent(value)
      document.cookie = `${name}=${value};path=/;${
        maxAge !== null ? `max-age=${maxAge};` : ''
      }`
    },
  }